import h from '../h';
import { formatDay } from '../utils';
export default function Bar(_ref) {
  var styles = _ref.styles,
      data = _ref.data,
      unit = _ref.unit,
      height = _ref.height,
      offsetY = _ref.offsetY,
      minTime = _ref.minTime,
      showDelay = _ref.showDelay,
      rowHeight = _ref.rowHeight,
      barHeight = _ref.barHeight,
      maxTextWidth = _ref.maxTextWidth,
      current = _ref.current,
      onClick = _ref.onClick;
  var x0 = maxTextWidth;
  var y0 = (rowHeight - barHeight) / 2 + offsetY;
  var cur = x0 + (current - minTime) / unit;
  return h("g", null, current > minTime ? h("line", {
    x1: cur,
    x2: cur,
    y1: offsetY,
    y2: height,
    style: styles.cline
  }) : null, data.map(function (v, i) {
    if (!v.end || !v.start) {
      return null;
    }

    var handler = function handler() {
      return onClick(v);
    };

    var x = x0 + (v.start - minTime) / unit;
    var y = y0 + i * rowHeight;
    var cy = y + barHeight / 2;

    if (v.type === 'milestone') {
      var size = barHeight / 2;
      var points = [[x, cy - size], [x + size, cy], [x, cy + size], [x - size, cy]].map(function (p) {
        return "".concat(p[0], ",").concat(p[1]);
      }).join(' ');
      return h("g", {
        key: i,
        "class": "gantt-bar",
        style: {
          cursor: 'pointer'
        },
        onClick: handler
      }, h("polygon", {
        points: points,
        style: styles.milestone,
        onClick: handler
      }), h("circle", {
        "class": "gantt-ctrl-start",
        "data-id": v.id,
        cx: x,
        cy: cy,
        r: 6,
        style: styles.ctrl
      }));
    }

    var w1 = (v.end - v.start) / unit;
    var w2 = w1 * v.percent;
    var bar = v.type === 'group' ? {
      back: styles.groupBack,
      front: styles.groupFront
    } : {
      back: styles.taskBack,
      front: styles.taskFront
    };

    if (showDelay) {
      if (x + w2 < cur && v.percent < 0.999999) {
        bar.back = styles.warning;
      }

      if (x + w1 < cur && v.percent < 0.999999) {
        bar.back = styles.danger;
      }
    }

    return h("g", {
      key: i,
      "class": "gantt-bar",
      style: {
        cursor: 'pointer'
      },
      onClick: handler
    }, h("text", {
      x: x - 4,
      y: cy,
      style: styles.text1
    }, formatDay(v.start)), h("text", {
      x: x + w1 + 4,
      y: cy,
      style: styles.text2
    }, formatDay(v.end)), h("rect", {
      x: x,
      y: y,
      width: w1,
      height: barHeight,
      rx: 1.8,
      ry: 1.8,
      style: bar.back,
      onClick: handler
    }), w2 > 0.000001 ? h("rect", {
      x: x,
      y: y,
      width: w2,
      height: barHeight,
      rx: 1.8,
      ry: 1.8,
      style: bar.front
    }) : null, v.type === 'group' ? null : h("g", null, h("circle", {
      "class": "gantt-ctrl-start",
      "data-id": v.id,
      cx: x - 12,
      cy: cy,
      r: 6,
      style: styles.ctrl
    }), h("circle", {
      "class": "gantt-ctrl-finish",
      "data-id": v.id,
      cx: x + w1 + 12,
      cy: cy,
      r: 6,
      style: styles.ctrl
    })));
  }));
}